import indexDbHelper from "./indexDbHelper";

/**
 * Clears all local data related to the order when it's closed by staff
 * This includes:
 * - All IndexedDB stores (orderItems, tableOrderItems)
 * - Vuex store state (cart items, current order ID, tip amount)
 * - localStorage data related to orders (checkoutCustomerInfo, checkoutSmsConsent)
 *
 * @param {Object} context - Vuex action context with dispatch function
 * @returns {Promise<void>}
 */
export async function clearAllOrderData({ dispatch }) {
  try {
    console.log("[OrderCleanup] Starting cleanup of all order data...");

    // 1. Clear all IndexedDB stores
    await indexDbHelper.clearAllData();
    console.log("[OrderCleanup] IndexedDB cleared");

    // 2. Clear Vuex store state
    if (dispatch) {
      // Clear table order module state
      await dispatch("tableOrder/clearCart", null, { root: true });
      await dispatch("tableOrder/clearOrderInfo", null, { root: true });

      // Also clear legacy order module if needed
      await dispatch("order/clearCart", null, { root: true });

      console.log("[OrderCleanup] Vuex store cleared");
    }

    // 3. Clear localStorage data related to orders
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        // Remove checkout-related data
        window.localStorage.removeItem("checkoutCustomerInfo");
        window.localStorage.removeItem("checkoutSmsConsent");
        console.log("[OrderCleanup] localStorage cleared");
      }
    } catch (localStorageError) {
      console.warn(
        "[OrderCleanup] Error clearing localStorage:",
        localStorageError
      );
      // Don't throw - localStorage might not be available in some contexts
    }

    console.log("[OrderCleanup] All order data cleared successfully");
  } catch (error) {
    console.error("[OrderCleanup] Error during cleanup:", error);
    throw error;
  }
}
